<template>
    <div class="containerLogin">
        <div class="left">
            <div class="headerLogin">
            <h2 class="animation a1">Overseas Test Tool System</h2>
            <h4 class="animation a2">Log in with your username and password</h4>
            </div>
            <div class="form">
                <input v-model="LoginUsername" type="email" class="form-field animation a3" placeholder="Username">
                <input v-model="LoginPassword" type="password" class="form-field animation a4" placeholder="Passcode">
                <p class="animation a5"><a href="#" @click="dialogForgetpwdEmailVisible = true">Forget Passcode</a></p>
                <button class="animation a6" @click="login()">Login</button>
            </div>
        </div>
        <div class="right"></div>
        <el-dialog title="Please enter your email address" :close-on-click-modal='false' :visible.sync="dialogForgetpwdEmailVisible">
            <el-form label-position="left" label-width="150px" class="ForgetpwdEmailForm">
                <el-form-item label="Email">
                    <el-input v-model="ForgetPassworEmail" placeholder="Please Enter Email"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogForgetpwdEmailVisible = false">Cancel</el-button>
                <el-button type="primary" @click="ForgetPasswordEmail">OK</el-button>
            </div>
        </el-dialog>
        <el-dialog title="Please enter your email address" :close-on-click-modal='false' :visible.sync="dialogForgetpwdVisible">
            <el-form label-position="left" label-width="150px" class="ForgetpwdEmailForm">
                <el-form-item label="Dynamic Code">
                    <el-input v-model="ForgetPassworDynamicCode" placeholder="Please Enter Dynamic Code"></el-input>
                </el-form-item>
                <el-form-item label="New Password">
                    <el-input v-model="ForgetPasswordNewpwd" placeholder="Please Enter New Password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="New Password Again">
                    <el-input v-model="ForgetPasswordNewpwdAgain" placeholder="Please Enter New Password Again" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogForgetpwdVisible = false">Cancel</el-button>
                <el-button type="primary" @click="ForgetPassword">OK</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loginData,ForgetPasswordEmailData,ForgetPasswordData } from '../../api/index';
export default {
    data() {
        return {
            LoginUsername: "",
            LoginPassword: "",
            dialogForgetpwdEmailVisible: false,
            ForgetPassworEmail: "",
            dialogForgetpwdVisible: false,
            ForgetPasswordNewpwd : "",
            ForgetPasswordNewpwdAgain : "",
            ForgetPassworDynamicCode : ""
        }
    },
    mounted(){
        window.addEventListener('keydown',this.keyDown);
    },
    methods: {
        login() {
            const LoginFormData = {
                username: this.LoginUsername,
                password: this.LoginPassword,
            }
            loginData (LoginFormData).then(res => {
                if (res.code == 1) {
                     this.$message({
                        message: "You're logged in!",
                        type: 'success'
                    });
                    const now = new Date()
                    const expirationDate = new Date(now.getTime() + 3600 * 1000)
                    localStorage.setItem("userName",res.user);
                    localStorage.setItem("userToken",res.token);
                    localStorage.setItem("Group",res.group);
                    localStorage.setItem("isLogin",true);
                    localStorage.setItem('expirationDate', expirationDate)
                    this.$store.dispatch("UserLoginIn",{
                        username: res.user,
                        usertoken: res.token,
                        usergroup: res.group
                    });
                    this.$store.dispatch("setLogoutTimer",3600);
                    console.log(this.$store.state.isLogin);
                    this.$router.push({path:'/overseastest'});
                }else {
                    this.$message({
                        message: 'Enter the correct username and password!',
                        type: 'warning'
                    })
                }
            }).catch(error => {
                this.$message({
                    message: 'Enter the correct username and password!',
                    type: 'warning'
                })
            });
            // .catch(error => console.log(error));           
            
        },
        keyDown(e){
            if(e.keyCode == 13 || e.keyCode ==100){
                this.login();
            }
        },
        ForgetPasswordEmail() {
            console.log("ForgetPasswordEmail");
            const ForgetPasswordEmailFormData = {
                email: this.ForgetPassworEmail
            }
            ForgetPasswordEmailData (ForgetPasswordEmailFormData).then(res => {
                console.log(res);
                console.log(res.code);
                if (res.code == 1) {
                    this.$message.success('Dynamic captcha has been sent to your email!');
                    this.dialogForgetpwdEmailVisible = false;
                    this.dialogForgetpwdVisible = true;
                }else {
                    this.$message.warning('Dynamic captcha failed to send, please contact administrator!');
                }
            }).catch(error => console.log(error));
        },
        ForgetPassword() {
            console.log("ForgetPassword");
            if(this.ForgetPasswordNewpwd == this.ForgetPasswordNewpwdAgain) {
                const ForgetPasswordFormData = {
                    verification: this.ForgetPassworDynamicCode,
                    email: this.ForgetPassworEmail,
                    password: this.ForgetPasswordNewpwd
                }
                ForgetPasswordData (ForgetPasswordFormData).then(res => {
                    if (res.code == 1) {
                        this.$message.success('Password has been changed, please login!');
                        this.ForgetPassworEmail = "";
                        this.ForgetPasswordNewpwd = "";
                        this.ForgetPasswordNewpwdAgain = "";
                        this.ForgetPassworDynamicCode = "";
                        this.dialogForgetpwdVisible = false;
                    }else {
                        this.$message.warning('Dynamic captcha error, change password failed!');
                    }
                }).catch(error => console.log(error));
            }else {
                this.$message.warning("Two passwords don't match, failed to change password!");
            }            
        }
    },
    destroyed(){
        window.removeEventListener('keydown',this.keyDown,false);
    }
}
</script>

<style lang="stylus" scoped>    
    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Rubik', sans-serif;
        margin:0;
        padding:0;
    }

    .containerLogin {
        display: flex;
        height: 100vh;
    }

    .left {
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        -webkit-animation-name: left;
                animation-name: left;
        -webkit-animation-duration: 1s;
                animation-duration: 1s;
        -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
        -webkit-animation-delay: 1s;
                animation-delay: 1s;
    }

    .right {
        flex: 1;
        background-color: black;
        transition: 1s;
        background-image: url(../../assets/img/photo.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .headerLogin > h2 {
        margin: 0;
        color: #4f46a5;
    }

    .headerLogin > h4 {
        margin-top: 10px;
        font-weight: normal;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.4);
    }

    .form {
        max-width: 80%;
        display: flex;
        flex-direction: column;
    }

    .form > p {
        text-align: right;
    }

    .form > p > a {
        color: #000;
        font-size: 14px;
    }

    .form-field {
        height: 46px;
        padding: 0 16px;
        border: 2px solid #ddd;
        border-radius: 4px;
        font-family: 'Rubik', sans-serif;
        outline: 0;
        transition: .2s;
        margin-top: 20px;
    }

    .form-field:focus {
        border-color: #0f7ef1;
    }

    .form > button {
        padding: 12px 10px;
        border: 0;
        background: linear-gradient(to right, #de48b5 0%, #0097ff 100%);
        border-radius: 3px;
        margin-top: 10px;
        color: #fff;
        letter-spacing: 1px;
        font-family: 'Rubik', sans-serif;
        cursor:pointer;
    }

    .animation {
        -webkit-animation-name: move;
                animation-name: move;
        -webkit-animation-duration: .4s;
                animation-duration: .4s;
        -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
        -webkit-animation-delay: 2s;
                animation-delay: 2s;
    }

    .a1 {
        -webkit-animation-delay: 2s;
                animation-delay: 2s;
    }

    .a2 {
        -webkit-animation-delay: 2.1s;
                animation-delay: 2.1s;
    }

    .a3 {
        -webkit-animation-delay: 2.2s;
                animation-delay: 2.2s;
    }

    .a4 {
        -webkit-animation-delay: 2.3s;
                animation-delay: 2.3s;
    }

    .a5 {
        -webkit-animation-delay: 2.4s;
                animation-delay: 2.4s;
    }

    .a6 {
        -webkit-animation-delay: 2.5s;
                animation-delay: 2.5s;
    }

    @-webkit-keyframes move {
        0% {
            opacity: 0;
            visibility: hidden;
            -webkit-transform: translateY(-40px);
                    transform: translateY(-40px);
        }
        100% {
            opacity: 1;
            visibility: visible;
            -webkit-transform: translateY(0);
                    transform: translateY(0);
        }
    }

    @keyframes move {
        0% {
            opacity: 0;
            visibility: hidden;
            -webkit-transform: translateY(-40px);
                    transform: translateY(-40px);
        }
        100% {
            opacity: 1;
            visibility: visible;
            -webkit-transform: translateY(0);
                    transform: translateY(0);
        }
    }
    @-webkit-keyframes left {
        0% {
            opacity: 0;
            width: 0;
        }
        100% {
            opacity: 1;
            padding: 20px 40px;
            width: 440px;
        }
    }
    @keyframes left {
        0% {
            opacity: 0;
            width: 0;
        }
        100% {
            opacity: 1;
            padding: 20px 40px;
            width: 440px;
        }
    }
</style>